import type { RisingCreatorStatus } from '../../hooks/useRisingCreators';

const STATUS_CONFIG: Record<RisingCreatorStatus, { label: string; className: string }> = {
  new: { label: 'Nouveau', className: 'bg-blue-50 text-blue-700 border-blue-200' },
  shortlisted: { label: 'Présélectionné', className: 'bg-amber-50 text-amber-700 border-amber-200' },
  contacted: { label: 'Contacté', className: 'bg-teal-50 text-teal-700 border-teal-200' },
  in_discussion: { label: 'En discussion', className: 'bg-orange-50 text-orange-700 border-orange-200' },
  signed: { label: 'Signé', className: 'bg-green-50 text-green-700 border-green-200' },
  rejected: { label: 'Rejeté', className: 'bg-red-50 text-red-700 border-red-200' },
};

export default function StatusBadge({ status }: { status: RisingCreatorStatus }) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.new;
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${config.className}`}>
      {config.label}
    </span>
  );
}

export { STATUS_CONFIG };
